import * as React from 'react';
import { Input, Select, Form, Modal } from 'antd';
import { observer } from 'mobx-react-lite';
import { RulesStores } from '../stores';
import { Connection } from '../models';
import { ConnectionResult } from '../types';
import { FormInstance } from 'antd/lib/form';
import { ConnectionReadOnlyCheckbox } from '../components';

type Props = {
    form: FormInstance;
    tempId: string;
} & RulesStores;
const TextArea = Input.TextArea;
export const ConnectionAddPage: React.FC<Props> = ({ RuleExternalConnections, form, tempId }) => {
    const store = RuleExternalConnections;

    const handleSubmit = () => {
        form.validateFields()
            .then((values: ConnectionResult) => {
                const conn = new Connection(values);
                if (!conn.isReadOnly) {
                    Modal.confirm({
                        title: 'Are you sure?',
                        content:
                            'Are you sure you want to save this connection without Read-only? If not, go back and enable Read-only to protect the SICS database.',
                        okText: 'OK',
                        cancelText: 'Cancel',
                        onOk: () => {
                            store!.save(conn, tempId);
                        }
                    });
                } else {
                    store!.save(conn, tempId);
                }
            })
            .catch(err => {
                console.log(err);
            });
    };

    return (
        <Form
            form={form}
            onFinish={handleSubmit}
            layout="vertical"
            id="add-rd-connection-form"
            data-id="add-rd-connection-dialog-form"
        >
            <Form.Item
                label="Name"
                name="name"
                rules={[
                    {
                        required: true,
                        message: 'Please input connection name!'
                    }
                ]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                label="Connection Type"
                name="connectionType"
                rules={[
                    {
                        required: true,
                        message: 'Please input connection type!'
                    }
                ]}
            >
                <Select>
                    <Select.Option value={'SqlServer'}>SqlServer</Select.Option>
                    <Select.Option value={'MongoDb'}>MongoDb</Select.Option>
                </Select>
            </Form.Item>
            <Form.Item
                label="Connection String"
                name="connectionString"
                rules={[
                    {
                        required: true,
                        message: 'Please input connection string!'
                    }
                ]}
            >
                <TextArea />
            </Form.Item>
            <ConnectionReadOnlyCheckbox />
        </Form>
    );
};

export default observer(ConnectionAddPage);
